import EventActionProto from '../event-action-proto';

export default class SessionEventTimerTask extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId);

        this.method = sessionEvent.method;
        this.fromSID = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false;

        switch (this.method) {
            case 'task-start':
                return this._taskStart()
            case 'task-stop':
                return this._taskStop()
            default:
                console.error("ERROR #SessionEventTimerTask-1 Unknown method", this.method)
                break;
        }
    }

    _taskStart() {
        gd.taskTimers.startTimer(this.data.task)
    }

    _taskStop() {
        gd.taskTimers.stopTimer(this.data.task.id)
    }

}
